import { v4 as uuidv4 } from 'uuid';

const SESSION_ID_KEY = 'sailUISessionId';
const SESSION_TIMESTAMP_KEY = 'sailUISessionTimestamp';
const SESSION_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours

export const sessionService = {
    // Initialize or get existing session ID
    getSessionId: (): string => {
        let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
        const timestamp = sessionStorage.getItem(SESSION_TIMESTAMP_KEY);

        // Check if session is expired
        if (sessionId && timestamp) {
            const lastActivity = parseInt(timestamp, 10);
            if (Date.now() - lastActivity > SESSION_TIMEOUT) {
                sessionService.clearSession();
                sessionId = null;
            }
        }

        if (!sessionId) {
            sessionId = uuidv4();
            sessionStorage.setItem(SESSION_ID_KEY, sessionId);
            sessionService.updateTimestamp();
        }

        return sessionId;
    },

    // Update last activity timestamp
    updateTimestamp: () => {
        sessionStorage.setItem(SESSION_TIMESTAMP_KEY, Date.now().toString());
    },

    // Check if there's an existing valid session
    hasExistingSession: (): boolean => {
        const sessionId = sessionStorage.getItem(SESSION_ID_KEY);
        const timestamp = sessionStorage.getItem(SESSION_TIMESTAMP_KEY);

        if (!sessionId || !timestamp) {
            return false;
        }

        const lastActivity = parseInt(timestamp, 10);
        return Date.now() - lastActivity <= SESSION_TIMEOUT;
    },

    // Store data in session storage with session ID prefix
    setSessionData: (key: string, data: any) => {
        const sessionId = sessionService.getSessionId();
        const sessionKey = `${sessionId}_${key}`;
        sessionStorage.setItem(sessionKey, JSON.stringify(data));
        sessionService.updateTimestamp();
    },

    // Get data from session storage
    getSessionData: (key: string): any => {
        const sessionId = sessionService.getSessionId();
        const sessionKey = `${sessionId}_${key}`;
        const data = sessionStorage.getItem(sessionKey);
        sessionService.updateTimestamp();
        return data ? JSON.parse(data) : null;
    },

    // Clear session
    clearSession: () => {
        sessionStorage.clear();
    }
};